import {
  IndexTable,
  LegacyCard,
  IndexFilters,
  useSetIndexFiltersMode,
  useIndexResourceState,
  Text,
  Badge,
  Checkbox,
  IndexFiltersMode,
  useBreakpoints,
  Button,
  Icon,
  Select,
  TextField,
} from '@shopify/polaris';
import { useState, useCallback, useEffect } from 'react';
import { jwtDecode } from 'jwt-decode';
import { DeleteIcon } from '@shopify/polaris-icons';
import { useLocation, useNavigate, NavLink } from 'react-router-dom';
import { ArrowLeftIcon } from '@shopify/polaris-icons';
import { useMemo } from "react";

export default function CustomerOrdres() {
  const navigate = useNavigate();
  const sleep = (ms) => new Promise((resolve) => setTimeout(resolve, ms));
  const [orders, setOrders] = useState([]);  // Initialize as an empty array
  const [itemStrings, setItemStrings] = useState([]);
  const { mode, setMode } = useSetIndexFiltersMode(IndexFiltersMode.Filtering);
  const [queryValue, setQueryValue] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [deleteorder, setDeleteOrder] = useState('');
  const [checkedOrders, setCheckedOrders] = useState({});
  const [updateOrder, setupdateOrder] = useState("");
  const [updateOrdercheckox, setupdateOrdercheckox] = useState("");
  const [adminCheck, setadminCheck] = useState("");
  const location = useLocation();
  const customersData = location.state?.customer;
  const customerID = customersData._id;
  const customerIdMain = customersData.customerId;
  const customerName = customersData?.json.name;

  const handleBack = () => {
    navigate(-1);
  };

  //Pagination state
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const onCreateNewView = async (value) => {
    await sleep(500);
    setItemStrings([...itemStrings, value]);
    return true;
  };

  const onHandleCancel = () => { };

  const tabs = itemStrings.map((item, index) => ({
    content: item,
    index,
    onAction: () => { },
    id: `${item}-${index}`,
    isLocked: index === 0,
    actions:
      index === 0
        ? []
        : [
        ],
  }));

  const handleQueryValueChange = useCallback(
    (value) => {
      setQueryValue(value);
    },
    []
  );
  const handleQueryValueRemove = useCallback(() => setQueryValue(''), []);

  const handleFiltersClearAll = useCallback(() => {
    handleQueryValueRemove();
  }, [
    handleQueryValueRemove,
  ]);

  const filters = [];
  const appliedFilters = [];

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      clearTimeout(timer);
      timer = setTimeout(() => func(...args), delay);
    };
  }

  const fetchCustomers = useCallback(async () => {
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_API_URL;
    if (!token) return;
    const decoded = jwtDecode(token);
    const RepsId = customersData?.json.repsid;
    const checkRole = decoded.role;
    setadminCheck(checkRole);
    setIsLoading(true);

    try {
      let url = '';
      if (deleteorder) {
        url = `${baseUrl}/api/orders/${deleteorder}`;
      } else if (updateOrder) {
        url = `${baseUrl}/api/orders/${updateOrder}`;
      } else {
        url = queryValue
          ? `${baseUrl}/api/orders/customer?search=${encodeURIComponent(queryValue)}&page=${page}&limit=10&repsid=${RepsId}&CustomerID=${customerIdMain}`
          : `${baseUrl}/api/orders/customer?page=${page}&limit=10&repsid=${RepsId}&CustomerID=${customerIdMain}`;
      }

      const method = deleteorder ? "DELETE" : updateOrder ? "PUT" : "GET";
      const requestBody = updateOrder
        ? JSON.stringify({
          Complete: updateOrdercheckox,
          outside: true,
        })
        : null;

      const response = await fetch(url, {
        method,
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: requestBody,
      });

      const data = await response.json();

      if (deleteorder) setDeleteOrder('');
      if (updateOrder) setupdateOrder('');

      if (data.Orders && Array.isArray(data.Orders)) {
        setOrders(data.Orders);
        setTotalPages(data.totalPages);
        const initialCheckedState = {};
        data.Orders.forEach((order) => {
          initialCheckedState[order._id] = order.Complete === "true";
        });
        setCheckedOrders(initialCheckedState);
      } else {
        setOrders([]);
      }
    } catch (error) {
      console.error("Error fetching Orders:", error.message);
    } finally {
      setIsLoading(false);
    }
  }, [
    queryValue,
    page,
    deleteorder,
    updateOrder,
    updateOrdercheckox,
    customerIdMain,
    customersData
  ]);

  const debouncedFetch = useMemo(() => debounce(fetchCustomers, 400), [fetchCustomers]);

  useEffect(() => {
    debouncedFetch();
  }, [debouncedFetch]);


  const resourceName = {
    singular: 'order',
    plural: 'orders',
  };

  const orderDelete = (id) => {
    setDeleteOrder(id);
  };

  const handleCheckboxChange = async (orderId, newCheckedState) => {
    setCheckedOrders((prevState) => ({
      ...prevState,
      [orderId]: newCheckedState,
      outside: true,
    }));
    setupdateOrdercheckox(newCheckedState);
    setupdateOrder(orderId);
  };
  const toneMap = {
    Draft: '',
    Submitted: 'info',
    Production: 'warning',
    Shipping: 'attention',
    Delivered: 'success',
  };

  const orderStatusChange = async (selectedOption, id) => {
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_API_URL;
    const updatedOrders = orders.map((order) =>
      order._id === id ? { ...order, orderStatus: selectedOption } : order
    );
    setOrders(updatedOrders);
    const payload = {
      orderStatus: selectedOption,
      outside: true,
    };

    try {
      const response = await fetch(`${baseUrl}/api/orders/${id}`, {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        return;
      }

      const data = await response.json();

    } catch (error) {
      console.error("Fetch Error:", error);
    }
  };

  const handleChangeTag = async (index, id, value, typeName) => {
    const token = localStorage.getItem("token");
    const baseUrl = process.env.REACT_APP_API_URL;
    const updatedOrders = [...orders];
    updatedOrders[index] = {
      ...updatedOrders[index],
      [typeName]: value
    };
    setOrders(updatedOrders);

    setTimeout(async () => {
      const payloadTag = {
        [typeName]: value,
        outside: true,
      };

      try {
        const response = await fetch(`${baseUrl}/api/orders/${id}`, {
          method: "PUT",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payloadTag),
        });

        if (!response.ok) {
          return;
        }

      } catch (error) {
        console.error("Fetch Error:", error);
      }
    }, 1000);
  };

  const optionsStatus = [
    { label: 'Draft', value: 'Draft' },
    { label: 'Submitted', value: 'Submitted' },
    { label: 'Production', value: 'Production' },
    { label: 'Shipping', value: 'Shipping' },
    { label: 'Delivered', value: 'Delivered' },
  ];

  const { selectedResources } =
    useIndexResourceState(orders);

  const formatDate = (isoDate) => {
    const dateObj = new Date(isoDate);
    return dateObj.toLocaleDateString('en-US', {
      month: 'long',
      day: 'numeric',
      year: 'numeric',
    });
  };
  const rowMarkup = orders && orders.length > 0
    ? orders.map(
      (
        { orderId, createdAt, orderStatus, _id, tags, tagNote, json },
        index
      ) => (
        <IndexTable.Row
          id={orderId}
          key={orderId}
          selected={selectedResources.includes(orderId)}
          position={index}
        >
          <IndexTable.Cell>
            <NavLink
              to={`/dashboard/orders/view/${_id}`}
              state={{ orderData: orders[index] }}
            >
              <Text variant="bodyMd" fontWeight="bold" as="span">
                {orderId}
              </Text>
            </NavLink>
          </IndexTable.Cell>
          <IndexTable.Cell>{json?.customerName}</IndexTable.Cell>
          <IndexTable.Cell>{json?.repName}</IndexTable.Cell>
          <IndexTable.Cell>{json?.Itemtype}</IndexTable.Cell>
          <IndexTable.Cell>{json?.FabricNumber}</IndexTable.Cell>
          <IndexTable.Cell>
            {adminCheck === "admin" ? (
              <div className={`status_select_box status_${(orderStatus || "").toLowerCase()}`}>
                <Select
                  options={optionsStatus}
                  value={orderStatus}
                  onChange={(selectedOption) => orderStatusChange(selectedOption, _id)} />
              </div>
            ) : (
              <Badge tone={toneMap[orderStatus] || 'default'}>
                {orderStatus}
              </Badge>
            )}
          </IndexTable.Cell>
          {adminCheck === "admin" ? (
            <IndexTable.Cell>
              <div className="text_input_box">
                <TextField
                  label=""
                  value={tags}
                  onChange={(value) => handleChangeTag(index, _id, value, 'tags')}
                  autoComplete="off"
                />
              </div>
            </IndexTable.Cell>
          ) : null}

          <IndexTable.Cell>
            <div className="text_input_box">
              <TextField
                label=""
                value={tagNote}
                onChange={(value) => handleChangeTag(index, _id, value, 'tagNote')}
                autoComplete="off"
              />
            </div>
          </IndexTable.Cell>
          <IndexTable.Cell>
            <>
              <div className='cutomer_update_btn'>
                {orderStatus === 'Submitted' && (
                  <NavLink to={`/dashboard/orders/${_id}`} state={{ orderData: orders[index] }}>Edit Order</NavLink>
                )}
                <NavLink to={`/dashboard/orders/reorder/${_id}`} state={{ orderData: orders[index] }}>
                  Re-Order
                </NavLink>
                {orderStatus === "Submitted" && (
                  <span onClick={() => orderDelete(_id)} style={{ cursor: 'pointer' }}>
                    <Icon source={DeleteIcon} tone="base" />
                  </span>
                )}
              </div>
            </>
          </IndexTable.Cell>
          <IndexTable.Cell>
            {adminCheck === "sales" ? (
              <Checkbox
                label=""
                checked={checkedOrders[_id]}
                onChange={(newCheckedState) =>
                  handleCheckboxChange(_id, newCheckedState)
                }
              />
            ) : checkedOrders[_id] ? (
              <span>True</span>
            ) : <span>False</span>}
          </IndexTable.Cell>
          <IndexTable.Cell>{formatDate(createdAt)}</IndexTable.Cell>
        </IndexTable.Row>
      )
    )
    : (
      <IndexTable.Row>
        <IndexTable.Cell colSpan={7}>No Orders found</IndexTable.Cell>
      </IndexTable.Row>
    );

  const handlePageChange = (newPage) => {
    if (newPage >= 1 && newPage <= totalPages) {
      setPage(newPage);
    }
  };

  return (
    <>
      <div className='button_option'>
        <h2><span onClick={handleBack}><Icon source={ArrowLeftIcon} tone="base" /></span> Customer: {customerName}</h2>
        <div className='topButton'>
          <NavLink to={`/dashboard/customers/${customerID}`} state={{ customer: customersData }}>
            <Button>Edit Customer</Button>
          </NavLink>
          <NavLink to="/dashboard/orders/create" state={{ customer: customersData }}>
            <Button>Create Order</Button>
          </NavLink>
        </div>
      </div>
      <LegacyCard>
        <IndexFilters
          loading={isLoading}
          queryValue={queryValue}
          queryPlaceholder="Search customers"
          onQueryChange={handleQueryValueChange}
          onQueryClear={handleQueryValueRemove}
          cancelAction={{
            onAction: onHandleCancel,
            disabled: false,
            loading: false,
          }}
          tabs={tabs}
          canCreateNewView
          onCreateNewView={onCreateNewView}
          filters={filters}
          appliedFilters={appliedFilters}
          onClearAll={handleFiltersClearAll}
          mode={mode}
          setMode={setMode} />

        <IndexTable
          condensed={useBreakpoints().smDown}
          resourceName={resourceName}
          itemCount={orders.length}
          headings={[
            { title: 'Order ID' },
            { title: 'Customer' },
            { title: 'Sales Rep' },
            { title: 'Item' },
            { title: 'Fabric Number' },
            { title: 'Status' },
            ...(adminCheck === "admin" ? [{ title: "Tags" }] : []),
            { title: "Note" },
            { title: 'Action' },
            { title: 'Complete' },
            { title: 'Created Date' },
          ]}
          selectable={false}
          pagination={{
            hasNext: page < totalPages,
            onNext: () => handlePageChange(page + 1),
            hasPrevious: page > 1,
            onPrevious: () => handlePageChange(page - 1),
            currentPage: page,
            totalPages,
          }}
        >
          {rowMarkup}
        </IndexTable>
      </LegacyCard>
    </>
  );
}